var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pause_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pause_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.486 0H6.448C5.648 0 5 .632 5 1.412v33.176C5 35.368 5.648 36 6.448 36h8.038c.8 0 1.448-.632 1.448-1.412V1.412c0-.78-.648-1.412-1.448-1.412ZM33.552 0h-8.038c-.8 0-1.448.632-1.448 1.412v33.176c0 .78.648 1.412 1.448 1.412h8.038c.8 0 1.448-.632 1.448-1.412V1.412C35 .632 34.352 0 33.552 0Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pause_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v37H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pause_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5)",
    d: "M0 0h30v36H0z"
  })))));
};
export default SvgPause;